import { Send, Globe, Instagram, Mail, Link as LinkIcon } from "lucide-react";
import type { LucideIcon } from "lucide-react";

export function socialIconFor(url: string): LucideIcon {
  const u = url.toLowerCase();
  if (u.includes("t.me") || u.includes("telegram")) return Send;
  if (u.includes("wa.me") || u.includes("whatsapp")) return Send;
  if (u.includes("instagram")) return Instagram;
  if (u.startsWith("mailto:") || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(u)) return Mail;
  if (u.startsWith("http")) return Globe;
  return LinkIcon;
}

export function normalizeHref(url: string): string {
  const s = url.trim();
  if (/^(https?:|mailto:|tel:)/i.test(s)) return s;
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s)) return `mailto:${s}`;
  return `https://${s}`;
}

export function socialLabel(url: string): string {
  const u = url.toLowerCase().trim();
  if (u.includes("t.me") || u.includes("telegram")) return "Telegram";
  if (u.includes("wa.me") || u.includes("whatsapp")) return "WhatsApp";
  if (u.includes("instagram")) return "Instagram";
  if (u.startsWith("mailto:") || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(u)) return "Email";
  return url.replace(/^https?:\/\//, "").replace(/\/$/, "");
}

/** Ссылка на Telegram из поля профиля; битую ссылку не строим. */
export function telegramHref(raw: string | null | undefined): string | null {
  const s = (raw ?? "").trim();
  if (!s) return null;
  if (/t\.me|telegram/i.test(s)) return normalizeHref(s);
  const name = s.replace(/^@+/, "");
  return /^[A-Za-z][A-Za-z0-9_]{3,31}$/.test(name) ? `https://t.me/${name}` : null;
}

/** Telegram-ссылка с готовым текстом сообщения (?text=…). */
export function withTelegramText(url: string, text: string): string {
  return `${url}${url.includes("?") ? "&" : "?"}text=${encodeURIComponent(text)}`;
}
